import styled from 'styled-components'

const Description = styled.div`
  color: hsl(0, 0%, 40%);
  font-size: 16px;
  line-height: 1.5;
`

export default Description
